// extracted by mini-css-extract-plugin
module.exports = {"phoneFieldParent":"sign-up_phoneFieldParent__3IBDf","disclaimer":"sign-up_disclaimer__3kfPV","resendHeader":"sign-up_resendHeader__11uxM"};